import Vue from "vue";
import widgetContentItemsMutations from '../general/widget-content-items/mutations';

export const SET_PROJECT_ID = 'setProjectId';
export const SET_ACCOUNT_NAME = 'setAccountName';
export const SET_PATH = 'setPath';
export const SET_SIDEBAR = 'setSidebar';
export const SET_SIDEBAR_WIDTH = 'setSidebarWidth';
export const SET_SIDEBAR_IS_FETCH = 'setIsFetch';
export const SET_WINDOW_WIDTH_SIDEBAR = 'setWindowWidthSidebar';

export default {
  ...widgetContentItemsMutations,
  [SET_PROJECT_ID](state, projectId = null) {
    state.sidebar.projectId = projectId;
  },
  [SET_PATH](state, path = null) {
    state.sidebar.path = path;
  },
  [SET_ACCOUNT_NAME](state, accountName = null) {
    state.sidebar.accountName = accountName;
  },
  [SET_SIDEBAR](state, data) {
    for (let key in data) {
      Vue.set(state.sidebar, key, data[key]);
    }
  },
  [SET_SIDEBAR_WIDTH](state, width = 0) {
    state.sidebar.width = width;
  },
  [SET_SIDEBAR_IS_FETCH](state, isFetch = false) {
    state.sidebar.isFetch = isFetch;
  },
  [SET_WINDOW_WIDTH_SIDEBAR](state, windowWidth = 0) {
    state.sidebar.windowWidth = windowWidth;
  }
}
